import React from "react";
import AppBar from "./AppBar.tsx";
import './App.css';
import { Navigate, Route, Routes } from "react-router-dom";
import pages from "./pages.ts";
import AlbumPage from "./AlbumPage.tsx";

export default function App() {
    return <>
        <AppBar />
        <Routes>
            {pages.map(page => <Route key={page.url} path={page.url} element={<AlbumPage page={page}/>}/>)}
            <Route path="*" element={<Navigate to={"/2020"}/>} />
        </Routes>
    </>;
}